var exports = {
  "iU": "Message.module__message___ZmZCLU",
  "Ph": "Message.module__messagePreviewSpacing___ZmZCLU",
  "IL": "Message.module__messagePreview___ZmZCLU",
  "Xo": "Message.module__messageHovered___ZmZCLU",
  "uK": "Message.module__focusRingAnchor___ZmZCLU",
  "J8": "Message.module__messageCompact___ZmZCLU",
  "L8": "Message.module__messageMentioned___ZmZCLU",
  "m6": "Message.module__messageReplying___ZmZCLU",
  "O6": "Message.module__messageHighlight___ZmZCLU",
  "lY": "Message.module__contextMenuActive___ZmZCLU",
  "Bc": "Message.module__mobileLayout___ZmZCLU",
  "p2": "Message.module__messageLongPress___ZmZCLU",
  "Uw": "Message.module__messageGrouped___ZmZCLU",
  "kT": "Message.module__messageEditing___ZmZCLU",
  "E4": "Message.module__messageSent___ZmZCLU",
  "mr": "Message.module__messageSending___ZmZCLU",
  "b$": "Message.module__messageFailed___ZmZCLU",
  "RZ": "Message.module__failedFooter___ZmZCLU",
  "Iu": "Message.module__failedFooterMessage___ZmZCLU",
  "bg": "Message.module__failedFooterLabel___ZmZCLU",
  "OZ": "Message.module__failedFooterIcon___ZmZCLU",
  "dv": "Message.module__failedRetryIcon___ZmZCLU",
  "QW": "Message.module__failedRetryButton___ZmZCLU",
  "q5": "Message.module__messageGutterLeft___ZmZCLU",
  "ZN": "Message.module__messageGutterRight___ZmZCLU",
  "$7": "Message.module__messageAvatar___ZmZCLU",
  "CW": "Message.module__messageNoText___ZmZCLU",
  "U7": "Message.module__messageContent___ZmZCLU",
  "rO": "Message.module__messageAuthorInfo___ZmZCLU",
  "xW": "Message.module__jumpHeading___ZmZCLU",
  "RO": "Message.module__jumpHeadingButton___ZmZCLU",
  "dw": "Message.module__messageAuthorRow___ZmZCLU",
  "AY": "Message.module__messageAuthorPart___ZmZCLU",
  "x": "Message.module__userTagOffset___ZmZCLU",
  "oL": "Message.module__messageTimestamp___ZmZCLU",
  "BK": "Message.module__authorDashSeparator___ZmZCLU",
  "um": "Message.module__messageUsername___ZmZCLU",
  "Lo": "Message.module__messageText___ZmZCLU",
  "L5": "Message.module__messageTimestampCompact___ZmZCLU",
  "tQ": "Message.module__compactAuthorPrefix___ZmZCLU",
  "U6": "Message.module__copyOnly___ZmZCLU",
  "Mz": "Message.module__compactInlineContent___ZmZCLU",
  "aM": "Message.module__systemMessageContent___ZmZCLU",
  "vp": "Message.module__contextMenuUnderline___ZmZCLU",
  "aE": "Message.module__messageTimeoutIndicator___ZmZCLU",
  "t4": "Message.module__textSeparator___ZmZCLU",
  "KL": "Message.module__messageTimestampHover___ZmZCLU",
  "jh": "Message.module__messageTimestampCompactHover___ZmZCLU",
  "iZ": "Message.module__messageAvatarCompact___ZmZCLU",
  "kq": "Message.module__compactContentWrapper___ZmZCLU",
  "xv": "Message.module__hoverAction___ZmZCLU",
  "kL": "Message.module__container___ZmZCLU",
  "tI": "Message.module__repliedMessage___ZmZCLU",
  "_T": "Message.module__repliedMessageCompact___ZmZCLU",
  "$y": "Message.module__repliedTextPreview___ZmZCLU",
  "NL": "Message.module__repliedAvatar___ZmZCLU",
  "a3": "Message.module__repliedIconContainer___ZmZCLU",
  "Pq": "Message.module__repliedIcon___ZmZCLU",
  "EK": "Message.module__repliedUsername___ZmZCLU",
  "IQ": "Message.module__repliedItalic___ZmZCLU",
  "t": "Message.module__unstyled___ZmZCLU",
  "Io": "Message.module__repliedTextContent___ZmZCLU",
  "c": "Message.module__systemMessageFollowsSystem___ZmZCLU",
  "Hj": "Message.module__systemMessageIconWrapper___ZmZCLU",
  "Po": "Message.module__systemMessageIconCompact___ZmZCLU",
  "jJ": "Message.module__systemMessageTimestamp___ZmZCLU",
  "rc": "Message.module__systemMessageContentWrapper___ZmZCLU",
  "V_": "Message.module__systemMessageCompactContent___ZmZCLU",
  "Gq": "Message.module__systemMessageIconSvg___ZmZCLU",
  "hr": "Message.module__systemMessageLink___ZmZCLU",
  "ll": "Message.module__userTagCompact___ZmZCLU",
  "O4": "Message.module__editedTimestamp___ZmZCLU",
  "k8": "Message.module__editedLabel___ZmZCLU",
  "zX": "Message.module__typingContainer___ZmZCLU",
  "Y9": "Message.module__typingCluster___ZmZCLU",
  "RL": "Message.module__typingIndicator___ZmZCLU",
  "Kl": "Message.module__typingAvatarContainer___ZmZCLU",
  "tY": "Message.module__typingText___ZmZCLU",
  "AZ": "Message.module__typingClusterComposerStatus___ZmZCLU",
  "am": "Message.module__compactContentNoPrefix___ZmZCLU",
  "Ys": "Message.module__compactBody___ZmZCLU",
  "Ac": "Message.module__unknownMessageCompactContent___ZmZCLU",
  "qU": "Message.module__unknownMessageWarning___ZmZCLU",
  "NG": "Message.module__keyboardFocused___ZmZCLU",
  "an": "Message.module__messageClientSystem___ZmZCLU",
  "og": "Message.module__systemMessageContainer___ZmZCLU",
  "Is": "Message.module__systemMessageIcon___ZmZCLU",
  "ry": "Message.module__mediaFocusRing___ZmZCLU",
  "xS": "Message.module__systemMessageDismissButton___ZmZCLU",
  "Eu": "Message.module__silentMessageIcon___ZmZCLU",
};

module.exports = exports;
